<template>
  <div class="relative bg-gray-800 rounded-xl border border-gray-500 py-2 px-2">
    <div
      v-if="this.hidden || this.balanceNative(this.wallet.address) <= 0.001"
      class="w-full h-full absolute left-0 top-0 rounded-xl bg-gray-800 opacity-80 z-10"
    ></div>
    <div
      class="absolute bg-green-800 rounded-full z-20 right-2 top-2 cursor-pointer text-gray-100 hover:text-blue-500"
      v-if="this.hidden"
      @click="this.show"
    >
      <tooltip text="Show wallet" position="left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </tooltip>
    </div>
    <div
      class="flex flex-wrap justify-between items-center gap-4 xl:gap-6 2xl:gap-8"
    >
      <div class="text-sm flex items-center gap-2">
        <div class="font-bold">{{ this.wallet.name }}:</div>
        <a
          target="_blank"
          :href="this.explorerUrlAddress(this.wallet.address)"
          class="text-sm hover:underline hover:text-blue-500"
        >
          {{ this.shortAddress(this.wallet.address) }}
        </a>
        <copy :value="this.wallet.address" />
        <copy :value="this.wallet.privateKey">
          <template #icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 text-gray-500"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
              />
            </svg>
          </template>
        </copy>
      </div>
      <div class="flex justify-between items-center">
        <div class="text-sm gap-1 flex items-center">
          <div class="font-bold text-red-400">
            {{ balanceFormat(this.balanceNative(this.wallet.address)) }}
          </div>
          <div>{{ this.wrappedToken }}</div>
        </div>
      </div>
      <div
        class="cursor-pointer text-gray-400 hover:text-blue-500"
        @click="this.hide"
      >
        <tooltip text="Hide wallet" position="left">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </tooltip>
      </div>
    </div>
    <div
      v-if="this.mgs"
      class="mt-1 break-words text-[11px] text-yellow-500 italic"
      v-html="this.mgs"
    ></div>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
import { mapActions, mapGetters } from "vuex";
import Copy from "@/components/Copy.vue";
import { ethers } from "ethers";

export default {
  name: "CollectBalance",
  components: { Copy, Tooltip },
  props: {
    wallet: {
      type: Object,
      required: true,
    },
    executeExcludeWallet: {
      type: Function,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    executeAddress: {
      type: String,
    },
    recipientAddress: {
      type: String,
    },
  },
  data() {
    return {
      copyValue: false,
      hidden: false,
      mgs: null,
    };
  },
  watch: {
    active() {
      this.hidden = false;
      this.mgs = null;
    },
    executeAddress() {
      if (this.executeAddress === this.wallet.address) {
        this.execute();
      }
    },
  },
  computed: {
    ...mapGetters("app", ["balanceFormat"]),
    ...mapGetters("network", [
      "wrappedToken",
      "explorerUrlAddress",
      "explorerUrlTxn",
      "shortAddress",
    ]),
    ...mapGetters("wallet", ["balanceNative"]),
    ...mapGetters("ethereum", ["getBalanceNative"]),
  },
  methods: {
    ...mapActions("ethereum", ["transferBalanceNative"]),
    hide() {
      this.hidden = true;
      this.$props.executeExcludeWallet(this.wallet);
    },
    show() {
      this.hidden = false;
      this.$props.executeExcludeWallet(this.wallet, false);
    },
    async execute() {
      try {
        this.mgs = "Collecting...";
        const recipientAddress = this.recipientAddress;
        const balance = await this.getBalanceNative(this.wallet.address);
        const amount = ethers.utils.formatEther(balance).toString();
        const transaction = await this.transferBalanceNative({
          wallet: this.wallet,
          recipientAddress,
          amount,
        });
        this.mgs = `Transaction pending... <a class="text-blue-500 hover:underline" target="_blank" href="${this.explorerUrlTxn(
          transaction.hash
        )}">Txn</a>`;
        const receipt = await transaction.wait(1);
        this.mgs = `Transcation confirmed! <a class="text-blue-500 hover:underline" target="_blank" href="${this.explorerUrlTxn(
          receipt.transactionHash
        )}">Txn</a>`;
      } catch (e) {
        console.log(e);
        this.mgs = e.message;
      }
    },
  },
};
</script>
